"use strict";
/**
 * @copyright 2020 Microsoft Corporation
 */
var $dyn;
(function ($dyn) {
    var ax;
    (function (ax) {
        // tslint:disable-next-line:class-name
        var formPersonalizationController = /** @class */ (function () {
            function formPersonalizationController() {
                this._formClosing = false;
                this.control = null;
                this.qtip = null;
            }
            formPersonalizationController.prototype.destroyQTip = function () {
                if (this.qtip) {
                    this.restoreActiveForm();
                    this.clearIndicator();
                    this.control = null;
                    this.clearQtipRepositionInterval();
                    this.qtip.destroy(true);
                    this.qtip = null;
                    $dyn.ax.formPersonalizationPane.qTipDestroyed.raise();
                }
            };
            formPersonalizationController.prototype.getPersonalizationOptions = function (controlName, contextSubControl) {
                var personalizationOptions;
                if (controlName &&
                    controlName !== "SystemDefinedShowFiltersButton" &&
                    controlName !== "SystemDefinedShowListButton" &&
                    controlName !== "SystemDefinedManageViewFilters") {
                    var controlAllowsPersonalization = $dyn.ax.personalizationUtil.isControlPersonalizable(contextSubControl);
                    var personalizationAllowed = $dyn.value(contextSubControl.Root.AllowExplicitPersonalization) && controlAllowsPersonalization;
                    if (personalizationAllowed) {
                        var label_1 = $dyn.value(contextSubControl.Label);
                        label_1 = label_1 ? label_1 : $dyn.value(contextSubControl.Caption);
                        if (!label_1 && contextSubControl instanceof $dyn.controls.Part && contextSubControl.PartForm && contextSubControl.PartForm.Caption) {
                            label_1 = $dyn.value(contextSubControl.PartForm.Caption);
                        }
                        label_1 = $dyn.format($dyn.label("ContextMenu_PersonalizationControl"), label_1 ? label_1 : controlName);
                        // Add a "Personalization" context menu item for the control
                        // This launches the personalization tooltip
                        personalizationOptions = {
                            Command: function () {
                                $dyn.ax.formPersonalizationPane.formPersonalizationController.openPersonalizationUI(contextSubControl);
                            },
                            Label: label_1,
                        };
                    }
                }
                return personalizationOptions;
            };
            formPersonalizationController.prototype.openPersonalizationUI = function (controlContext) {
                if (!this.handledForAppHostControl(controlContext)) {
                    this.openQuickPersonalizationForm(controlContext);
                }
            };
            formPersonalizationController.prototype.restoreActiveForm = function () {
                if (this._previouslyActiveForm) {
                    $dyn.shell.activateElement(this._previouslyActiveForm);
                    this._previouslyActiveForm = null;
                }
            };
            formPersonalizationController.prototype.clearIndicator = function () {
                if (this.control) {
                    $($dyn.ui.selector().css($dyn.ui.personalizationClasses.personalizedElement).toString()).removeClass($dyn.ui.personalizationClasses.personalizedElement);
                }
            };
            formPersonalizationController.prototype.clearQtipRepositionInterval = function () {
                if (this.qtipRepositionInterval) {
                    window.clearInterval(this.qtipRepositionInterval);
                    this.qtipRepositionInterval = null;
                }
            };
            formPersonalizationController.prototype.handledForAppHostControl = function (controlContext) {
                if (typeof (controlContext) === "object") {
                    if ($dyn.controls.WebsiteHostControl && controlContext instanceof $dyn.controls.WebsiteHostControl) {
                        $dyn.ax.formPersonalizationPane.formPersonalizationToolbar.SelectForEditWebsiteHostControl(controlContext);
                        $dyn.ax.formPersonalizationPane.formPersonalizationToolbar.shouldTarget = true;
                        return true;
                    }
                    if ($dyn.controls.PowerAppsHost && controlContext instanceof $dyn.controls.PowerAppsHost || controlContext.Name === "SysPAMenuButton") {
                        $dyn.ax.formPersonalizationPane.formPersonalizationToolbar.SelectForEditPAControl(controlContext);
                        $dyn.ax.formPersonalizationPane.formPersonalizationToolbar.shouldTarget = true;
                        return true;
                    }
                }
                return false;
            };
            formPersonalizationController.prototype.openQuickPersonalizationForm = function (controlContext) {
                var _this = this;
                if (!controlContext) {
                    return;
                }
                // Reject deferreds and unsubscribe from observables to cancel previous update
                if (this.clientIsNotBusy) {
                    this.clientIsNotBusy.reject();
                }
                if (this.clientBusySubscription) {
                    this.clientBusySubscription.dispose && this.clientBusySubscription.dispose();
                    this.clientBusySubscription = undefined;
                }
                // Unsubscribe and cancel deferreds here
                this.clientIsNotBusy = $.Deferred();
                this.clientBusySubscription = $dyn.observe(function () {
                    return !$dyn.value($dyn.clientBusy);
                }, function (value) {
                    if (value) {
                        _this.clientIsNotBusy && _this.clientIsNotBusy.resolve();
                        return false;
                    }
                });
                $.when(this.clientIsNotBusy).done(function () {
                    var target = controlContext.element;
                    if (controlContext.getPersonalizationElements) {
                        // qtips should always target the first personalization element.
                        target = controlContext.getPersonalizationElements()[0];
                    }
                    var options = {
                        adjustMethod: "flip",
                        at: "right center",
                        my: "left center",
                    };
                    var minDistance = 300;
                    var windowWidth = $(window).width();
                    var leftEdge = $(target).offset().left;
                    var width = $(target).width();
                    var right = leftEdge + width;
                    var rightEdge = windowWidth - right;
                    if (leftEdge < minDistance && rightEdge < minDistance) {
                        // If the element is too close to both the rigth and left edges of the window (within 300px of both) then change the qtip position to be top/bottom
                        options.my = "top center";
                        options.at = "bottom center";
                    }
                    // Destroy previous qtip
                    _this.destroyQTip();
                    _this.control = controlContext;
                    _this._contentPlaceholder = document.createElement("form");
                    _this._contentPlaceholder.setAttribute("data-dyn-template", "templateId: 'Popup'");
                    _this.qtip = $(target).qtip({
                        content: {
                            text: $(_this._contentPlaceholder)
                        },
                        events: {
                            hide: function () {
                                if (!_this._formClosing) {
                                    // Check for current form and close
                                    if (_this._personalizationForm) {
                                        $dyn.callFunction(_this._personalizationForm.RequestClose, _this._personalizationForm);
                                        _this._personalizationForm = null;
                                    }
                                    // Restore previously active form
                                    _this.restoreActiveForm();
                                    // Destroy the qtip
                                    // Must be done in a timeout since this is currently inside the blur method.
                                    window.setTimeout(function () {
                                        _this.destroyQTip();
                                    }, 100);
                                }
                            }
                        },
                        hide: "unfocus",
                        position: {
                            adjust: {
                                method: options.adjustMethod
                            },
                            at: options.at,
                            my: options.my,
                            target: $(target),
                            viewport: $(window),
                        },
                        show: false,
                        style: {
                            classes: "formPersonaliztion-popup qtip-light baseDirection",
                            tip: {
                                height: 8,
                                width: 16,
                            },
                        },
                    }).qtip("api");
                    _this.clearQtipRepositionInterval();
                    _this.qtipRepositionInterval = window.setInterval(function repositionQTip() {
                        // Check if the element is visible
                        if ($dyn.value(controlContext.Visible) && this.qtip) {
                            // Don't reposition for controls in the React Grid
                            if (!(controlContext && controlContext.Root && controlContext.Root.UseReactGrid()) || !controlContext.isInGrid()) {
                                this.qtip.reposition(null, true);
                            }
                        }
                    }, 500);
                    // Create new form
                    $dyn.async(function () { return _this.loadPersonalizationForm(); }, undefined, "Load Personalization Form");
                    _this.clientIsNotBusy = null;
                });
            };
            formPersonalizationController.prototype.loadPersonalizationForm = function () {
                var _this = this;
                var formOptions = {
                    canGoBack: false,
                    name: "FormControlPersonalizationPane",
                    role: "Popup",
                    ShouldBlockOnExecution: false,
                    targetElement: this._contentPlaceholder,
                };
                var nestedForm = $dyn.shell.createForm(formOptions);
                this._clientFormId = nestedForm.getAttribute("data-dyn-formid");
                this._personalizationForm = $dyn.context(nestedForm);
                // Override default Open behavior for this form
                this._personalizationForm.Open = function () {
                    if (_this.control) {
                        // If the control is in the React Grid, scroll the row into view
                        if (_this.control.Root && _this.control.Root.UseReactGrid() && _this.control.isInGrid()) {
                            _this.control.listControl && _this.control.listControl.scrollActiveRowIntoView();
                        }
                        _this._personalizationForm.IsOpen(true);
                        // Wait a bit before showing the tip to accomodate animations and layout changes
                        window.setTimeout(function () {
                            if (!_this.qtip) {
                                // Error case, this should exist
                                $dyn.logError("qtip should not have been destroyed before showing");
                            }
                            else {
                                if (_this.control) {
                                    _this._previouslyActiveForm = $dyn.shell.getActiveForm();
                                    $dyn.shell.activateElement(nestedForm);
                                    _this.control.element.classList.add($dyn.ui.personalizationClasses.personalizedElement);
                                    $dyn.ax.personalizationUtil.addClassToBreakableGroups(_this.control.element, $dyn.ui.personalizationClasses.personalizedElement);
                                    _this.qtip.show();
                                }
                            }
                        });
                    }
                    else {
                        // Close the form if the control was removed before it could open
                        _this._personalizationForm.Close();
                    }
                };
                this._personalizationForm.closeCallback = function () {
                    // Set the formClosing flag so that we don't try to duplicate closing the qtip in the blur method
                    _this._formClosing = true;
                    // When the form is removed, we should ensure the qtip is destroyed
                    _this.destroyQTip();
                    _this._formClosing = false;
                };
                if ($dyn.serverForm) {
                    $dyn.serverForm.registerForm({
                        targetElement: nestedForm,
                    });
                }
                $dyn.callFunction(this.control.ExecutePersonalizationCommand, this.control, ["LaunchPersonalizationPane", this._clientFormId]);
            };
            return formPersonalizationController;
        }());
        ax.formPersonalizationController = formPersonalizationController;
    })(ax = $dyn.ax || ($dyn.ax = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FormPersonalizationController.js.map
